export const calculateScrollbarLength = (
  containerLength: number,
  viewportLength: number
) => {
  if (containerLength > viewportLength) {
    return viewportLength * viewportLength / containerLength;
  }
  return 0;
};

export const calculateScrollbarDistanceFromStart = (
  containerLength: number,
  viewportLength: number,
  distanceScrolled: number
) => {
  return distanceScrolled * (viewportLength / containerLength);
};

export const calculateScrollDimensions = (
  containerLength: number,
  viewportLength: number,
  distanceScrolled: number
) => {
  return {
    length: calculateScrollbarLength(containerLength, viewportLength),
    offset: calculateScrollbarDistanceFromStart(
      containerLength,
      viewportLength,
      distanceScrolled
    )
  };
};

// Mouse position references either the X or the Y coordinate of the mouse
export const calculateScrollOffsetWhenDraggingScrollbar = (
  containerLength: number,
  viewportLength: number,
  mousePositionWhenStarted: number,
  mousePositionCurrently: number
) => {
  return (
    (mousePositionCurrently - mousePositionWhenStarted) *
    (viewportLength / containerLength)
  );
};
